import TournamentCardController from './TournamentCardController'
import TournamentOverviewTabs from './TournamentOverviewTabs'

// Screen root for TOURNAMENT_DETAIL. The full tournament row is passed via
// navigation params (see useTournamentNavigation) rather than re-fetched —
// there is no "get tournament by id" query, only list/history.
const TournamentDetail = ({ tournament, origin }) => {
  if (!tournament) return null

  return (
    <div className="standard-normal-tournament-detail-outer-container">
      <div className="standard-normal-tournament-detail-card-container">
        <TournamentCardController tournament={tournament} origin={origin} variant="detail" />
      </div>
      <div className="standard-normal-tournament-detail-overview-container">
        <TournamentOverviewTabs tournament={tournament} origin={origin} />
      </div>
    </div>
  )
}

export default TournamentDetail
